import Typography from "@mui/material/Typography";
import SecondaryButton from "../secondaryButton";
import { Link } from "react-router-dom";
import { Box } from "@mui/material";

export default function Success() {
  return (
    <Box
      sx={{
        height: "95vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography variant="body1" color="text.secondary">
        Your purchase was successful!
      </Typography>
      <Link to={"/products"}>
        <SecondaryButton val={"Back to the products"} />
      </Link>
    </Box>
  );
}
